import React, { useEffect, useState } from "react";
import ContentCard from "../../common/template/contentCard";
import Select from "../../common/form/select";
import Grid from "../../common/layout/grid";
import Button from "../../common/button/button";
import Row from "../../common/layout/row";
import NumberFormat from "react-number-format";
import DateFormat from "../../common/dateFormat/DateFormat";

export function DefinirEnergiaDiaForm(props) {
    const [ano, mes, dia] = String(props.dataGrafico).split("-");
    if (!ano || !mes || !dia) return <div style={{ color: "red" }}>Erro ao exibir formulário para incluir leitura</div>;

    const [exibirForm, setExibirForm] = useState(false);

    const ultimoDia = DateFormat.obterUltimoDiaFechadoOuAtualDoMes(ano, mes);

    const formDefault = {
        ano,
        mes,
        dia: ultimoDia,
        data_hora: `${ano}-${mes}-${ultimoDia} 23:59:59`,
        energia_dia_string: "0",
        energia_dia: 0,
        id_geracao_integracao: props.idGeracaoIntegracao,
    };
    const [form, setForm] = useState(formDefault);

    //quando muda o mes do gráfico, troca o mes e ano padrão do form
    useEffect(() => {
        const ultimoDiaMesSelecionado = DateFormat.obterUltimoDiaFechadoOuAtualDoMes(ano, mes);
        setForm({
            ...form,
            ano: ano,
            mes: mes,
            dia: ultimoDiaMesSelecionado,
            data_hora: `${ano}-${mes}-${ultimoDiaMesSelecionado} 23:59:59`,
        });
    }, [props.dataGrafico]);

    // gera a lista
    const listaDias = Array.from({ length: ultimoDia }, (_, i) => {
        const valor = i + 1;
        const valorFormatado = valor < 10 ? "0" + valor : "" + valor;
        return { id: valorFormatado, valor: valorFormatado };
    });

    if (!exibirForm) {
        return (
            <ContentCard style={{ width: "100%", padding: 20 }}>
                <Row alignCenter>
                    <Button
                        text="Definir Energia do Dia"
                        type={"primary"}
                        icon={"fas fa-edit"}
                        event={() => {
                            setExibirForm(true);
                        }}
                    />
                </Row>
            </ContentCard>
        );
    }

    return (
        <ContentCard style={{ width: "100%", padding: 20 }}>
            <Row alignCenter>
                <Select
                    name="dia"
                    options={listaDias}
                    label="Dia"
                    cols="6 6 6 6"
                    placeholder="Selecione o Dia"
                    value={form.data_hora.substring(8, 10)}
                    onChange={(value) => {
                        setForm({
                            ...form,
                            dia: value,
                            data_hora: `${ano}-${mes}-${value} 23:59:59`,
                        });
                    }}
                />

                <Grid cols="6 6 6 6">
                    <label>Energia do Dia ({`${form.dia}/${form.mes}/${form.ano}`})</label>
                    <NumberFormat
                        className="form-control"
                        style={{ height: 40, fontSize: 13 }}
                        placeholder={"0"}
                        decimalSeparator={","}
                        decimalScale={2}
                        fixedDecimalScale={2}
                        value={form.energia_dia_string}
                        onValueChange={(values) => {
                            setForm({
                                ...form,
                                energia_dia: values.floatValue,
                                energia_dia_string: values.formattedValue,
                            });
                        }}
                    />
                </Grid>
            </Row>
            <Row alignCenter>
                <Grid cols="6 6 6 6">
                    <Button
                        style={{ margin: 0 }}
                        text="Incluir"
                        type={"success"}
                        icon={"fa fa-check"}
                        event={() => {
                            props.handleSubmit(form);
                            setForm(formDefault);
                            setExibirForm(false);
                        }}
                    />
                </Grid>

                <Grid cols="6 6 6 6">
                    <Button
                        style={{ margin: 0 }}
                        text="Cancelar"
                        type={"danger"}
                        icon={"fa fa-times"}
                        event={() => {
                            setForm(formDefault);
                            setExibirForm(false);
                        }}
                    />
                </Grid>
            </Row>
        </ContentCard>
    );
}
